import React from "react";
import BaseStatusBadgeIcon from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function StatusBadgeIcon(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(BaseStatusBadgeIcon, {
    children: children
  });
}
export default StatusBadgeIcon;